import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import type { AuthState } from "../auth/AuthProvider";
import { meQueryOptions } from "../queries";

function VehiclesRoute() {
  return <VehiclesScreen auth={Route.useRouteContext().auth} />;
}

export const Route = createFileRoute("/_authed/vehicles")({
  component: VehiclesRoute,
});

// Saved vehicles stay visible. Add and remove stay hidden until a subject write exists.
export function VehiclesScreen({ auth }: { auth: AuthState }) {
  const me = useQuery(meQueryOptions(auth));

  if (me.isLoading) return <main className="grid min-h-[60vh] place-items-center text-slate-400">Loading…</main>;
  const vehicles = me.data?.vehicles ?? [];

  return (
    <main className="mx-auto max-w-lg space-y-3 p-4">
      <h1 className="text-lg font-semibold text-slate-800">Your vehicles</h1>
      {vehicles.length === 0 && (
        <p className="rounded-xl border border-dashed border-slate-300 p-6 text-center text-slate-500">
          No saved vehicles yet.
        </p>
      )}
      {vehicles.map((v) => (
        <section key={v.registration} className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-mono font-semibold text-slate-800">{v.registration}</p>
              <p className="text-sm text-slate-500">
                {[v.colour, v.make, v.model].filter(Boolean).join(" ") || "—"}
              </p>
            </div>
            <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-500">{v.size}</span>
          </div>
        </section>
      ))}
    </main>
  );
}
